import { MessageDescriptor, useIntl } from "react-intl";

export interface Descriptor extends MessageDescriptor {
  id: string | undefined;
}

export const useMessage = () => {
  const intl = useIntl();

  const message = (
    { id, defaultMessage, description }: Descriptor,
    values?: any,
    opts?: any,
  ) => {
    try {
      return intl.formatMessage(
        { id, defaultMessage, description },
        values,
        opts,
      );
    } catch (err) {
      return "";
    }
  };

  return {
    message,
  };
};
